import axios from 'axios'
import constants from '../constants'

const SHUTTERSTOCK_URL = 'https://api.shutterstock.com/v2';
const SHUTTERSTOCK_KEY = '2457c-bb5f6-26e64-d9a32-66337-b6ebe';
const SHUTTERSTOCK_SECRET = '94605-e3352-782a1-55652-6238e-42c08';

const MEMBERS_PATH = `${constants.urlPrefix}/api/members`;
const VISITORS_PATH = MEMBERS_PATH + '/visitors';
const FREE_IMAGE_PATH = `${constants.urlPrefix}/api/freeImage`

const encodeAuthorization = function () {
  return 'Basic ' + window.btoa(SHUTTERSTOCK_KEY + ':' + SHUTTERSTOCK_SECRET);
};

const instance = axios.create({
  headers: {
    Authorization: encodeAuthorization()
  }
});

const searchImage = function (query) {
  return instance.get(SHUTTERSTOCK_URL + '/images/search', {
    params: {
      query,
      per_page: 100
    }
  });
};

const uploadMemberImage = function (memberId, formData) {
  return axios.post(`${MEMBERS_PATH}/${memberId}/images/upload`, formData);
};

const uploadMemberIcon = function (memberId, formData) {
  return axios.post(`${MEMBERS_PATH}/${memberId}/icons/upload`, formData);
};

const uploadMemberLogo = function (memberId, formData) {
  return axios.post(`${MEMBERS_PATH}/${memberId}/logos/upload`, formData);
};

const replaceMemberImage = function (memberId, formData) {
  return axios.post(`${MEMBERS_PATH}/${memberId}/images/replace`, formData);
};

const updateImageAltText = function (imagePath, altText) {
  return axios.post(`${MEMBERS_PATH}/images/altText`, {}, { params: { imagePath, altText } });
}

const updateIconAltText = function (iconId, altText) {
  return axios.post(`${MEMBERS_PATH}/icons/altText`, {}, { params: { iconId, altText } });
}

const uploadVisitorImage = function (visitorId, formData) {
  return axios.post(`${VISITORS_PATH}/${visitorId}/images/upload`, formData);
};

const uploadVisitorIcon = function (visitorId, formData) {
  return axios.post(`${VISITORS_PATH}/${visitorId}/icons/upload`, formData);
};

const uploadQRPdf = function (memberId, formData) {
  return axios.post(`${MEMBERS_PATH}/${memberId}/qr/pdf/upload`, formData);
};

const removeMemberImage = function (imageId) {
  return axios.delete(`${MEMBERS_PATH}/images/${imageId}`);
};

const removeMemberIcon = function (iconId) {
  return axios.delete(`${MEMBERS_PATH}/icons/${iconId}`);
};

const getMemberImages = function (memberId) {
  return axios.get(`${MEMBERS_PATH}/${memberId}/images`);
};

const getLocationImages = function (memberId, locationId) {
  return axios.get(`${MEMBERS_PATH}/${memberId}/images`, {
    params: {locationId}
  });
};

const getVisitorImages = function (visitorId) {
  return axios.get(`${VISITORS_PATH}/${visitorId}/images`);
};

const getFreeImages = function () {
  return axios.get(constants.urlPrefix + '/api/images/free');
};

const searchPixabayImages = function(searchTerm, page) {
  return axios.get(constants.urlPrefix + '/api/images/pixabay/', {
    params: {
      query: searchTerm,
      page: page
    }
  });
}

const searchPixabayImagesPerIds = function(ids) {
  return axios.get(constants.urlPrefix + '/api/images/pixabay/ids', {
    params: {
      ids: ids
    }
  });
}

const searchPixabayVideos = function(searchTerm, page) {
  return axios.get(constants.urlPrefix + '/api/videos/pixabay/', {
    params: {
      query: searchTerm,
      page: page
    }
  });
}

const searchPexelsVideos = function(searchTerm, page) {
  return axios.get(constants.urlPrefix + '/api/videos/pexels/', {
    params: {
      query: searchTerm,
      page: page
    }
  });
}

const uploadPixabayImage = function(url, previewURL, id) {
  return axios.get(constants.urlPrefix + '/api/images/pixabay/upload', {
    params: {
      url: url,
      previewURL: previewURL,
      id: id
    }
  });
}

const getMemberRecentImages = function(memberId) {
  return axios.get(constants.urlPrefix + '/api/images/pixabay/recent', {
    params: {
      memberId: memberId
    }
  });
}

const pushMemberRecentImage = function(memberId, pixabayId, largeImageURL, previewURL, user, pageURL) {
  return axios.get(constants.urlPrefix + '/api/images/pixabay/recent/new', {
    params: {
      memberId: memberId,
      pixabayId: pixabayId,
      largeImageURL: largeImageURL,
      previewURL: previewURL,
      user: user,
      pageURL: pageURL
    }
  })
}

const clearRecentImages = function(memberId) {
  return axios.get(constants.urlPrefix + '/api/images/pixabay/recent/clear', {
    params: {
      memberId: memberId
    }
  });
}

const getLocationIcons = function (memberId, locationId) {
  return axios.get(`${MEMBERS_PATH}/${memberId}/icons`, {
    params: {locationId}
  });
};

const getMemberIcons = function (memberId) {
  return axios.get(`${MEMBERS_PATH}/${memberId}/icons`);
};

const getVisitorIcons = function (visitorId) {
  return axios.get(`${VISITORS_PATH}/${visitorId}/icons`);
};

const updateImage = function (dto) {
  return axios.put(FREE_IMAGE_PATH, dto);
}

const uploadFreeImage = function (formData) {
  axios.post(`${FREE_IMAGE_PATH}/upload`, formData);
}

export function getS3Path(path) {
  return constants.SECURE_S3_PATH + path;
}

export function getFreeImageThumbPath(path) {
  if (!path) return "";
  const bits = path.split("/");
  const name = bits[bits.length - 1].split(".");
  return getS3Path("public/free-images-thumbs/thumb-" + name[0] + ".webp");
}

export function getImageType(path) {
  if (!path) return "";
  const bits = path.split(".");
  if (!bits[1]) return "";
  if (bits[1] === "jpg" || bits[1] === "jpeg") return "image/jpeg";
  return "image/png";
}


export default {
  searchImage,
  getFreeImages,
  searchPixabayImages,
  searchPixabayImagesPerIds,
  searchPixabayVideos,
  searchPexelsVideos,
  uploadPixabayImage,
  getMemberRecentImages,
  pushMemberRecentImage,
  clearRecentImages,

  updateImage,
  uploadFreeImage,

  uploadMemberImage,
  uploadMemberIcon,
  uploadMemberLogo,
  uploadQRPdf,
  uploadVisitorImage,
  uploadVisitorIcon,
  replaceMemberImage,
  updateImageAltText,
  updateIconAltText,

  getMemberImages,
  getLocationIcons,
  getLocationImages,
  getVisitorImages,
  removeMemberImage,
  removeMemberIcon,
  getMemberIcons,
  getVisitorIcons
}
